import { useCallback, useMemo, useState } from "react";
import debounce from "lodash/debounce";
import { SuggestProvider } from "./SuggestProvider";
var DEBOUNCE_TIME_MS = 250;
export var useSearchSuggestions = function(language, market, settings) {
    var ref = useState(false), loading = ref[0], setLoading = ref[1];
    var ref1 = useState(null), results = ref1[0], setResults = ref1[1];
    var searchSuggestProvider = useMemo(function() {
        return SuggestProvider.getInstance(settings, language, market);
    }, [
        settings,
        language,
        market
    ]);
    var sendRequest = useCallback(function(searchString) {
        searchSuggestProvider.sendRequest(searchString).then(function(searchResults) {
            setLoading(false);
            setResults(searchResults);
        }).catch(function() {
            setLoading(false);
        });
    }, [
        searchSuggestProvider
    ]);
    var debouncedSendRequest = useMemo(function() {
        return debounce(sendRequest, DEBOUNCE_TIME_MS);
    }, [
        sendRequest
    ]);
    var fetchSuggestions = useCallback(function(searchString) {
        setLoading(true);
        debouncedSendRequest(searchString);
    }, [
        debouncedSendRequest
    ]);
    return {
        clearResults: function() {
            setResults([]);
        },
        fetchSuggestions: fetchSuggestions,
        loading: loading,
        results: results
    };
};
